/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { isEmpty } from 'modules/common/helpers/object';
import styles from 'modules/transactions/components/inner-filter/inner-filter.module.scss';
/**
 * Compare hotels window component common for the dashboard component
 * @param {Array} hotelList - hotel list
 * @param {*} focusOn - selected compared hotels
 * @param {Function} handleCompareHotelsChange - Function to set compare hotels value
 * @returns
 */
const CompareHotelsWindow = ({ focusOn, hotelList, handleCompareHotelsChange }) => {
  //
  const [allHotelObj, setAllHotelObj] = useState({});
  useEffect(() => {
    if (isEmpty(allHotelObj) && hotelList.length > 0) {
      const allHotelObject = {};
      Object.keys(hotelList[0]).forEach((key) => {
        allHotelObject[key] = 'All';
      });
      setAllHotelObj([allHotelObject]);
    }
  }, [hotelList]);
  //
  return (
    <Autocomplete
      sx={{ width: { sm: 350 }, pb: { sm: 2, md: 0, lg: 0 } }}
      size="small"
      id="tags-outlined"
      className={styles.headerDropdown}
      options={!isEmpty(allHotelObj) ? hotelList?.concat(allHotelObj) : hotelList ?? []}
      getOptionLabel={(option) => (option.label ? option.label : '')}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={(e, value) => {
        handleCompareHotelsChange(e, value);
      }}
      disableClearable
      value={focusOn ?? null}
      renderInput={(params) => (
        <TextField label="Select Hotel" {...params} size="small" color="primary" />
      )}
      fullWidth
      componentsProps={{
        paper: {
          sx: {
            minWidth: 350,
            whiteSpace: 'unset',
            wordBreak: 'break-all',
          },
        },
      }}
    />
  );
};
//
export default CompareHotelsWindow;
